export type PortalRole = "LOCATAIRE" | "PROPRIETAIRE" | "ADMIN"

export type ServiceRequestCategory = "BRIS" | "ENTRETIEN" | "REPARATION" | "ACCES" | "AUTRE"
export type ServiceRequestPriority = "NORMAL" | "PRIORITAIRE" | "URGENT"
export type ServiceRequestStatus = "NOUVELLE" | "EN_ANALYSE" | "PLANIFIEE" | "TERMINEE"

export interface ServiceRequestAttachment {
  name: string
  type: "image/jpeg" | "image/png" | "image/webp"
  key?: string
  size?: number
  url?: string
}

export interface ServiceRequestMessage {
  senderId: string
  senderRole: string
  text: string
  createdAt: string
}

export interface ServiceRequest {
  id?: string
  _id?: string
  requesterId: string
  requesterRole: string
  requesterName: string
  requesterEmail: string
  propertyId?: string
  propertyLabel: string
  unit?: string
  category: ServiceRequestCategory
  priority: ServiceRequestPriority
  description: string
  availability?: string
  status: ServiceRequestStatus
  attachments: ServiceRequestAttachment[]
  messages: ServiceRequestMessage[]
  createdAt: string
  updatedAt: string
}

export interface CreateServiceRequestPayload {
  propertyId?: string
  propertyLabel: string
  unit?: string
  category: ServiceRequestCategory
  priority: ServiceRequestPriority
  description: string
  availability?: string
  attachments?: ServiceRequestAttachment[]
}

export const normalizePortalRole = (role?: string): PortalRole => {
  if (role === "ADMIN" || role === "LOCATAIRE" || role === "PROPRIETAIRE") {
    return role
  }
  return "PROPRIETAIRE"
}

export const roleLabel: Record<PortalRole, string> = {
  LOCATAIRE: "Espace locataire",
  PROPRIETAIRE: "Espace propriétaire",
  ADMIN: "Administration",
}

export const categoryLabel: Record<ServiceRequestCategory, string> = {
  BRIS: "Signaler un bris",
  ENTRETIEN: "Demande d’entretien",
  REPARATION: "Demande de réparation",
  ACCES: "Accès ou clés",
  AUTRE: "Autre demande",
}

export const statusLabel: Record<ServiceRequestStatus, string> = {
  NOUVELLE: "Reçue",
  EN_ANALYSE: "En analyse",
  PLANIFIEE: "Planifiée",
  TERMINEE: "Terminée",
}
